export const REPORT_FAILURE = "REPORT_FAILURE";
export type REPORT_FAILURE = typeof REPORT_FAILURE;

export const REPORT_REQUEST = "REPORT_REQUEST";
export type REPORT_REQUEST = typeof REPORT_REQUEST;

export const REPORT_SUCCESS = "REPORT_SUCCESS";
export type REPORT_SUCCESS = typeof REPORT_SUCCESS;

export const REPORT_UPDATE_SUCCESS = 'REPORT_UPDATE_SUCCESS';
export type REPORT_UPDATE_SUCCESS = typeof REPORT_UPDATE_SUCCESS;


// WEBPACK FOOTER //
// ./src/constants/report.constants.ts